var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-entrepreneur-video-decorative"},_vm._l((_vm.icons),function(icon,index){return _c('entrepreneur-video-decorative-item',{key:index,attrs:{"icon":icon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }